import { Card } from '@sravni/react-design-system';
import cn from 'classnames';
import type { ComponentProps } from 'react';
import { useCallback } from 'react';

import { QUERY_PARAMS } from 'constants/queryNames';
import { APP_PAGES_NAMES } from 'constants/routes';

import { FormStepId } from 'shared/config/formStepId';
import { NoSSR } from 'shared/ui/NoSSR';

import { useClientRedirect } from 'features/useClientRedirect';

import { HeroCalculator } from 'widgets/LoansHeroFormSection/ui/HeroCalculator';

import { HeroBackgroundDecor } from './HeroBackgroundDecor';
import { HeroContent } from './HeroContent';
import { HeroHeadingBlock } from './HeroHeadingBlock';
import styles from './LoansHeroFormSection.module.scss';

type Props = {
  className?: string;
};

export const LoansHeroFormSection: FC<Props> = (props) => {
  const { className } = props;

  const { push } = useClientRedirect();

  const onRedirectToForm: NonNullable<ComponentProps<typeof HeroCalculator>['onRedirectToForm']> = useCallback(() => {
    const params = new URLSearchParams(window.location.search);
    params.set(QUERY_PARAMS.FORM_STEP_ID, String(FormStepId.ContactsInfo));

    push(APP_PAGES_NAMES.NEW_FORM, params.toString());
  }, [push]);

  return (
    <Card className={cn(styles.heroCard, className)}>
      <HeroBackgroundDecor />
      <HeroContent>
        <HeroHeadingBlock />
        <NoSSR>
          <HeroCalculator
            className={styles.heroCalculator}
            onRedirectToForm={onRedirectToForm}
          />
        </NoSSR>
      </HeroContent>
    </Card>
  );
};
